import EmitirNota from './EmitirNota'

export default function EmitirCTeOS() {
  return <EmitirNota tipo="CTE" titulo="CT-e OS" />
}
